import * as React from "react"
import { Block } from "./library/container"
import { MediaBlockProps } from "../../custom_api/drupal_paragraph_to_block"
import { VideoRewriteSrc } from "./video_block"

export interface RichTextInlineMedia {
  position: "text_left" | "text_right"
  display: "masked" | "original"
  media: MediaBlockProps
}

export interface RichTextBlockProps {
  readonly title: string
  readonly html: string
  readonly primaryActionTitle?: string
  readonly primaryActionUrl?: string
  readonly secondaryActionTitle?: string
  readonly secondaryActionUrl?: string
  readonly media: "none" | RichTextInlineMedia
}

export const RichTextBlock: React.StatelessComponent<RichTextBlockProps> = p => {
  const media =
    p.media != "none" && p.media.media.kind == "image" ? (
      <div className="image-block__wrapper">
        <div className={`image-block__inner`}>
          <div className={`richtextt-block__visual ${p.media.display}`}>
            <img
              src="/bkw/images/bkw/empty.png"
              data-src={p.media.media.imageUrl}
              data-srcset={`${p.media.media.imageUrlSmall} 360w, ${p.media.media.imageUrl} 720w ${p.media.media.imageUrlLarge} 1080w`}
              alt={p.media.media.imageAlt}
              width="360"
              height="300"
              className="image-block__image lazyload"
            />
          </div>
        </div>
      </div>
    ) : p.media != "none" && p.media.media.kind == "video" ? (
      <div className="video-block__wrapper">
        <div className="video-block__inner">
          <iframe className="video-block__iframe" src={VideoRewriteSrc(p.media.media)} frameBorder="0" title={p.media.media.videoName} />
        </div>
      </div>
    ) : null

  return (
    <Block>
      <div className={`richtext-block container--sg align--center${p.media != "none" ? ' richtext-block--media' : ' richtext-block--plain'}`}>
        
        <div className={`richtext-block__media-container ${p.media != "none" ? p.media.position : ""} `}>
          {p.media != "none" && (
            <div className={`richtext-block__media richtext-block__media--${p.media.position}`}>
              {media}
            </div>
          )}
          <div className={`richtext-block__container-buttons`}>
            {p.title && (
              <h2 className="richtext-block__title title--l">{p.title}</h2>
            )}
            <div dangerouslySetInnerHTML={{ __html: p.html }} className="richtext-block__container text--styled" />

            {(p.primaryActionTitle != "" || p.secondaryActionTitle != "") && (
              <div className="richtext-block__buttons">
                {p.primaryActionTitle != "" && (
                  <a className="button button--primary button--arrow" href={p.primaryActionUrl}>
                    <span className="button__label">{p.primaryActionTitle}</span>
                  </a>
                )}
                {p.secondaryActionTitle != "" && <a className="button button--secondary" href={p.secondaryActionUrl}><span className="button__label">{p.secondaryActionTitle}</span></a>}
              </div>
            )}
          </div>
        </div>
      </div>
    </Block>
  )
}

{/* TH: Added to styleguide! */}

